// reviews-data.js — Curated verified-buyer reviews + misfit flags
// Sourced from Lagoon Fera reviews (March 2026 export, 707 reviews).
// Used by the concierge agent in two ways:
//   1. The recommendation card surfaces ONE quote per match.
//   2. The system prompt receives summaries so Lumi can speak in
//      verified-buyer language ("Other side sleepers with neck pain...").
//   3. MISFIT_FLAGS are hard "do not recommend" signals pulled from
//      1-2 star returns — they down-weight wrong matches.

window.LAGOON_REVIEWS = {
  "otter": [
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "As advertised - cooling and supportive! Love this pillow (about 3 weeks in) and it's helping a lot with my shoulder pain (I'm a side sleeper)",
      "by": "Liz · Santa Cruz"
    },
    {
      "rating": 5,
      "title": "Love the feel of this pillow!",
      "body": "I’ve traditionally been a stomach/side sleeper, but I hurt my back several months ago and can now only sleep on my back. This pillow is awesome! I love the feel, slow sink (but actual sink, unlike other foam / non-shredded foam pillows), and support of this pillow!",
      "by": "Nicole · League City"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "I absolutely love the otter pillow. My head just sinks right into it and off to sleep I go. I wake up refreshed and in a good mood. It also keeps me cool when the weather get warm as well since it’s supportive and I’m not being swallowed by fluff.",
      "by": "Liz · Oreland"
    },
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "I wake up with no neck pain and I sleep comfortably throughout the night.",
      "by": "Julia · Aurora"
    },
    {
      "rating": 5,
      "title": "Excellent!",
      "body": "This pillow is amazing! I sleep so much better and my back and neck pain is gone! Would definitely recommend. I plan to purchase one for my husband, too.",
      "by": "emily · lafayette"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "love that it is cool and that i can shape it so my neck is in alignment... i sleep so much better... Thank you",
      "by": "Elizabeth · Laguna Beach"
    }
  ],
  "fox": [
    {
      "rating": 5,
      "title": "Great!",
      "body": "This is an excellent pillow! I am a side sleeper and it provides great head and neck support to keep my spine in good alignment. Also it is extremely comfortable!",
      "by": "Verified · Victoria"
    },
    {
      "rating": 5,
      "title": "How great!",
      "body": "I love how soft and supportive this pillow is. Even when you are sinking into the plushness of the pillow it still supports your neck and head perfectly.",
      "by": "Jeannine · Ventura"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "I love this pillow, I haven’t woken up with neck pain since I got it and I feel like I am better rested when I wake up!",
      "by": "Emma · Elk Point"
    },
    {
      "rating": 5,
      "title": "Impressive comfort and support!",
      "body": "After receiving my Otter pillow, I was impressed by its initial comfort. I did remove some fill after the first night to customize it to my liking, and since then, it has been perfect. The Otter pillow provides just the right support for my neck and back, allowing me to wake up feeling refreshed and without any stiffness. What I love most is how quickly it helps me fall asleep as soon as I lie down with it. Unlike my previous pillow, the Otter pillow isn't too firm, yet it still provides excellent support. This has significantly reduced my neck and shoulder pain, making my sleep experience truly restorative. I highly recommend the Otter pillow for anyone looking for a comfortable and supportive solution to their sleep needs.",
      "by": "Alyanna · Laguna"
    },
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "I love the cushion and support. I finally wake up without my neck hurting!",
      "by": "Rebecca · Roswell"
    },
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "I loved having the adjustable filling to make my pillow feel just right! My head is supported, but the pillow is still so soft. The perfect combination.",
      "by": "Elizabeth · Media"
    }
  ],
  "chinchilla": [
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "This is the best pillow I have ever purchased. I am a side/back sleeper with a bad neck and since purchase have not woke up with any neck pain. It’s so soft and cozy! I tell EVERYONE about my pillow! Highly recommend it!",
      "by": "Nordstrom · Princeton"
    },
    {
      "rating": 5,
      "title": "",
      "body": "I bought this second pillow. Its sift and nit firm. Its cool and comfortable. It’s the first pillow that I found that i love and sleep so well on.",
      "by": "CONNIE · Saint Petersburg"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "I have frequent neck pain and am a side-sleeper, but this pillow has been a game changer! I’ve had it for a month and do not wake up with pain! The pillow’s soft, but with enough support and compresses so comfortably under my head.",
      "by": "Nassim · Bellingham"
    },
    {
      "rating": 5,
      "title": "Great !!",
      "body": "I love the softness and instant comfort I feel when I lay my head on the pillow at night. It makes for a restful sleep each night. I love this pillow. The best pillow I have ever had. Thank you so much",
      "by": "Susan · Minneapolis"
    },
    {
      "rating": 5,
      "title": "Lovely!",
      "body": "I have tried just about every type of pillow in search of comfort. I am a side and back sleeper who gets migraines and occasional neck pain. I have found I like the soft feel of a down alternative, but also need the adjustable support. This pillow is perfect! The quality is great and it is the softest I've found. My only small complaint is that I wish it came with a little extra filling in case you need it. I did need to purchase more to get it just right. That aside I do recommend this pillow. Also the customer service at Lagoon is awesome. I tried the Otter first and it didn't work out. However I was easily able to return without issue. A little while later I am back and in love with the Chinchilla.! Thanks Lagoon!",
      "by": "Jaclyn · Bay Village"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "My husband and I have been looking for a new pillow for a long time now. We have gone through trying many highly rated pillows and have finally found the ones with Lagoon Sleeps Chinchilla Pillow. We both love our new pillows! My husband is more of a back sleeper and I am more of a side sleeper. We both tend to like a softer pillow. The Chinchilla was perfect for both of us. It gave that cloud like sink in feel we were looking for a the adjustable fill made it possible for us to each customize the loft to fit our liking (his a little more lofty and mine a little less). I would highly recommend!",
      "by": "Samantha · Covington"
    }
  ],
  "puffin": [
    {
      "rating": 5,
      "title": "Fantastic!",
      "body": "I love everything about this pillow. I am a stomach sleeper and finding a good pillow is almost impossible. Love this!",
      "by": "Matthew · Brentwood"
    },
    {
      "rating": 5,
      "title": "The Perfect Pillow (for me)",
      "body": "I love a minimal, soft pillow and with the quiz Lagoon absolutely nailed it! This is the softest pillow I have ever had, absolutely love my Puffin pillow!",
      "by": "Lynnette · Cary"
    },
    {
      "rating": 5,
      "title": "Highly recommended!",
      "body": "It's the perfect height for a stomach sleeper. A huge improvement over my current Avocado pillow.",
      "by": "Nicholas · Minneapolis"
    },
    {
      "rating": 5,
      "title": "My husband LOVES the puffin",
      "body": "He sleeps on his stomach and has always used really crummy pillows. I'm so happy to have finally found him one that works well... I can now finally throw out the others - yes!",
      "by": "Maria · Washington DC"
    },
    {
      "rating": 5,
      "title": "Can't sleep without it",
      "body": "I don't know if it's the pillow or the mindset I have because of the pillow, but I've been getting the best sleep of my life since I started using the pillows from Lagoon.",
      "by": "Jake · Minneapolis"
    },
    {
      "rating": 5,
      "title": "The search is over!",
      "body": "I’ve bought (and tossed) too many pillows to count! This one, however, will NOT get tossed because it’s absolutely perfect! I’m a stomach sleeper and The Puffin is so comfy. No more pillow shopping for me!",
      "by": "Marge · Boise"
    }
  ],
  "polarbear": [
    {
      "rating": 5,
      "title": "Holy Grail of pillows!",
      "body": "This thing is amazing! so adjustable and so comfortable. Stuart Scott would be happy- it's as cool as the other side of the pillow",
      "by": "Kenton · Pittsburgh"
    },
    {
      "rating": 5,
      "title": "The gold standard of pillows",
      "body": "As a marathon runner and a mom, sleep is one of the most important parts of recovery for me. The Lagoon Polar Bear pillow has been fantastic. I love that it’s adjustable so you can customize the height and support. I’m typically a side sleeper and it provides great neck support without feeling too firm or too flat. The pillow is so good I actually had to order more because my husband and kids kept trying to steal mine. When it comes to comfort, support, and thoughtful design, Lagoon really feels like the gold standard.",
      "by": "Kayla · Richmond Hill"
    }
  ]
};

window.LAGOON_REVIEW_SUMMARIES = {
  "otter": "Most loved by side sleepers with neck/shoulder pain. Real reviews: \"no neck pain\", \"head sinks right in\", \"alignment is perfect\", \"wake up refreshed\". Lightly cooling but visitors who NEED strong cooling should be steered to Polar Bear instead. Bulky for stomach sleepers — avoid that match.",
  "fox": "The brand best-seller and GQ-pick for combo sleepers. Adjustable fill is a key selling point — buyers love being able to remove fill to dial-in feel. Real reviews: \"no neck pain since I got it\", \"soft and supportive\", \"perfect cushion and support\". WARNING: side sleepers with broad shoulders sometimes find it under-supportive — those should go to Otter.",
  "chinchilla": "Soft, low-loft, \"sink in\" feel. Adored by side/back sleepers with neck pain who prefer plush over firm. Real reviews: \"best pillow ever\", \"neck pain gone\", \"instant comfort\". TOO SOFT for anyone who explicitly wants firm support.",
  "puffin": "Stomach-sleeper favorite. Reviews: \"perfect height for a stomach sleeper\", \"huge improvement\", \"search is over\". Soft + low-loft, kind to face-down sleepers. Also good for cold sleepers.",
  "polarbear": "The coolest pillow Lagoon makes. Adjustable fill. Reviews mention recovery sleep, marathon runners, \"as cool as the other side of the pillow\". Specifically for HOT sleepers who also want adjustability. Don't recommend to cold sleepers."
};

window.LAGOON_MISFIT_FLAGS = {
  "otter": [
    {
      "dim": "position",
      "value": "stomach",
      "penalty": 8,
      "why": "returns flagged \"too bulky for stomach sleepers\""
    },
    {
      "dim": "concern",
      "value": "hot",
      "penalty": 3,
      "why": "hot-sleepers expecting strong cooling are sometimes disappointed — Polar Bear is the better cooling answer"
    }
  ],
  "fox": [
    {
      "dim": "position",
      "value": "side",
      "penalty": 0,
      "why": "fine for most side sleepers"
    }
  ],
  "chinchilla": [
    {
      "dim": "density",
      "value": "firm",
      "penalty": 8,
      "why": "\"too soft\" complaints from firm-feel buyers"
    },
    {
      "dim": "body",
      "value": "broad",
      "penalty": 5,
      "why": "sinks too far for broad shoulders"
    }
  ],
  "puffin": [],
  "polarbear": [
    {
      "dim": "temp",
      "value": "cold",
      "penalty": 8,
      "why": "too cooling for cold sleepers"
    },
    {
      "dim": "density",
      "value": "soft",
      "penalty": 5,
      "why": "firmer than soft-feel buyers want"
    }
  ]
};

window.LAGOON_MISFIT_COMBOS = [
  {
    "pillow": "fox",
    "when": {
      "position": "side",
      "body": "broad"
    },
    "penalty": 6,
    "why": "broad-shouldered side sleepers report under-support — steer to Otter"
  },
  {
    "pillow": "chinchilla",
    "when": {
      "position": "side",
      "body": "broad"
    },
    "penalty": 8,
    "why": "too low/soft for broad-shouldered side sleepers"
  },
  {
    "pillow": "puffin",
    "when": {
      "temp": "hot"
    },
    "penalty": 7,
    "why": "Puffin is temp-neutral — wrong for hot sleepers"
  },
  {
    "pillow": "fox",
    "when": {
      "temp": "hot"
    },
    "penalty": 7,
    "why": "Fox is temp-neutral — Otter or Polar Bear is the cooling answer"
  },
  {
    "pillow": "chinchilla",
    "when": {
      "temp": "hot"
    },
    "penalty": 7,
    "why": "Chinchilla is temp-neutral — wrong for hot sleepers"
  }
];